/*银行账户 */
import { $http, buildHeaders } from "./index";

//获取客户下拉数据
export const bankaccount_select = (params) => {
  return $http.get("/admin/BankAccount/index", {
    params: { limit: 0, sort_field: "name", status: 1, ...params },
  });
};

//获取到账银行列表
export const bankaccount_list = (params) => {
  return $http.get("/admin/BankAccount/index", { params });
};

//获取到账银行详情
export const bankaccount_detail = (id) => {
  return $http.get("/admin/BankAccount/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加到账银行
export const bankaccount_add = (data) => {
  return $http.post("/admin/BankAccount/add", data, {
    headers: buildHeaders(3),
  });
};

//修改到账银行
export const bankaccount_edit = (data) => {
  return $http.post("/admin/BankAccount/edit", data, {
    headers: buildHeaders(3),
  });
};

//删除到账银行
export const bankaccount_delete = (id) => {
  return $http.post(
    "/admin/BankAccount/del",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};
